import axios from 'axios';

const api = axios.create({
  baseURL: 'https://mayne.jusprosistemas.com.br', // <-- Apontando para o domínio com HTTPS
  headers: {
    'Content-Type': 'application/json'
  }
});

// Antes de cada requisição, ele pega a chave do Login
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('mayne_token');
  if (token) {
    config.headers['X-API-Key'] = token;
  }
  return config;
});

export default api;